
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import moment from 'moment'
import descriptor from './EventsManagementDescriptor.json'
import ProgressSpinner from 'primevue/progressspinner'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default defineComponent({
    name: 'events-management',
    components: { ProgressSpinner, Card, Dropdown, Calendar, DataTable, Column },
    data() {
        return {
            descriptor,
            loading: false,
            events: [] as any,
            eventModel: descriptor.eventModel,
            startDate: null as any,
            endDate: null as any,
            selectedEventModel: '' as String,
            filters: { global: [filterDefault] } as Object,
            globalFilterFields: ['user', 'type'],
            lazyParams: { size: 20, paginationStart: 0 } as any,
            first: 0
        }
    },
    created() {
        this.getEvents()
    },
    methods: {
        async getEvents() {
            this.loading = true
            let url = process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/events/?fetchsize=${this.lazyParams.size}&offset=${this.lazyParams.paginationStart}`
            this.selectedEventModel != '' ? (url += `&type=${this.selectedEventModel}`) : ''
            this.startDate ? (url += `&startDate=${encodeURIComponent(moment(this.startDate).format('YYYY-MM-DD+HH:mm:ss'))}`) : ''
            this.endDate ? (url += `&endDate=${encodeURIComponent(moment(this.endDate).format('YYYY-MM-DD+HH:mm:ss'))}`) : ''
            await this.$http
                .get(url)
                .then((response: AxiosResponse<any>) => {
                    this.events = response.data.results
                    this.lazyParams.size = response.data.total
                    this.lazyParams.paginationStart = response.data.start
                })
                .finally(() => (this.loading = false))
        },
        async onPage(event: any) {
            this.lazyParams = { paginationStart: event.first, paginationLimit: event.rows, paginationEnd: event.first + event.rows, size: this.lazyParams.size }
            await this.getEvents()
        },
        async onSearchClicked() {
            this.first = 0
            this.lazyParams = { size: 20, paginationStart: 0 }
            await this.getEvents()
        },
        setFocusOnSearchButton() {
            this.$nextTick(() => {
                const searchButton = this.$refs['search-button'] as any
                searchButton.$el.focus()
            })
        }
    }
})
